import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ObservedValueOf } from 'rxjs/internal/types';
import { ListGridComponent } from '../../../../shared/listGrid/listGrid.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogsService } from '../../../../../core/services/dialog.service';
import { sortCaseInsensitive } from '../../../../../core/pure-functions/grids/grid-sorting-helper';
import { ContainsSubscriptions } from '../../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../../core/pure-functions/rx-helper';
import { CustomerDAO } from '../../../../../core/services/dao/customerDAO';
import { Customer } from 'anchor-shared/lib/model/entity/customer';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-unverified-customers',
  templateUrl: './unverified-customers.component.html',
  styleUrls: ['./unverified-customers.component.scss'],
})
export class UnverifiedCustomersComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  templateData$: Observable<{
    customers: ObservedValueOf<Observable<Customer[]>>;
  }>;
  subs: Subscription[] = [];

  columnDefs: any[];
  rowData: any[];
  editPath = 'manage/admin/user/edit';

  @ViewChild(ListGridComponent)
  grid: ListGridComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogsService,
    private customerDAO: CustomerDAO,
  ) {}

  ngOnInit() {
    this.initAsyncData();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  private createColumnDefs() {
    return [
      {
        headerName: 'Email',
        field: 'user.email',
        filter: 'text',
        minWidth: 50,
        comparator: sortCaseInsensitive,
      },
      {
        headerName: 'First Name',
        field: 'user.firstName',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
      {
        headerName: 'Last Name',
        field: 'user.lastName',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
      {
        headerName: 'Phone Number',
        field: 'user.phoneNumber',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
      {
        headerName: 'Notes',
        field: 'notes',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
      {
        headerName: 'Status',
        field: 'status',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
    ];
  }

  private initAsyncData(): void {
    this.templateData$ = this.customerDAO.adminGrid().pipe(
      map((customers) => {
        this.rowData = customers;
        this.columnDefs = this.createColumnDefs();
        return { customers };
      }),
    );
  }
}
